import { useMemo } from 'react';
import { Redirect, useLocation, useParams } from 'react-router-dom';
import { AppRouting } from '../../../../services/appRoutingResolver';
import PageLoader from '../../../application/components/page-loader/page-loader.component';
import { usePageFilters } from '../../../../hooks/use-page-filters.hooks';
import { useConversationGroupsInfinite } from '../../components/outreach/conversation-groups/conversation-groups-infinite.context';
import {
  ConversationsLoadingPage,
} from './conversation-loading.styled';

const ConversationLoading = (): JSX.Element | null => {
  const location = useLocation();
  const { positionId } = useParams<MatchUrlParams>();
  const {
    getFiltersByKey,
  } = usePageFilters();

  const selectedConversationGroupName = useMemo<string>(() => {
    return getFiltersByKey(AppRouting.URL_PARAMS.OUTREACH.CONVERSATION_GROUP)[0];
  }, [getFiltersByKey]);
  
  const { groupedConversations } = useConversationGroupsInfinite();

  const conversations = groupedConversations?.[selectedConversationGroupName]?.conversations;

  if (conversations?.length > 0) {
    return <Redirect to={ AppRouting.buildPositionConversationByIdPageUrl(positionId, conversations[0].id, location.search) } />;
  }

  return (
    <ConversationsLoadingPage>
      <PageLoader />
    </ConversationsLoadingPage>
  );
};

export default ConversationLoading;
